<template>
  <div class="info-card">
    <div class="info-card__top">
      <div class="info-card__plate">{{ city.id }}</div>
      <h3 class="info-card__name">{{ city.name }}</h3>
    </div>
    <div class="info-card__bottom">
      <div class="info-card__title">Popularity</div>
      <div class="info-card__count">{{ city.id }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CityInfoCard',
  props: {
    city: Object
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/info-card";
  .info-card {
    opacity: 1;
    background: #f4f7fb;
    display: block;
    height: auto;
  }

  .info-card__name {
    color: #17d3a5;
    font-size: 21px;
  }

  .info-card__plate {
    color: #4b5ba4;
    font-weight: 700;
    font-size: 35px;
    margin-bottom: 5px;
    line-height: 1em;
  }

  .info-card__top {
    padding: 20px 15px;
    padding-top: 25px;
    border-bottom: 1px solid #d4dbea;
  }

  .info-card__bottom {
    padding-bottom: 25px;
  }

  .info-card:hover .info-card__count {
    color: #535b78;
  }

  .info-card:hover .info-card__title {
    color: #656e8d;
  }

</style>
